import React from 'react';
import OrdersPage from './OrdersPage';

const Orders: React.FC = () => {
  return <OrdersPage />;
};

export default Orders;